/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var DragIcon = createIcon("DragIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#767676';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "12",
    height: "20",
    viewBox: "0 0 12 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3Zm0 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3ZM4.5 16a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0ZM9 5.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3Zm1.5 4.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0ZM9 17.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3Z",
    fill: _color
  }));
}, {
  "replaceColor": true
});